import './vendor';
import vars from './helpers';
import './components/social';
import './components/analytics';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import header from './components/header';
import lazyLoading from './modules/lazyLoading';
import scrollToAnchor from './modules/scrollToAnchor';
// import video from './components/video';
import AOS from 'aos';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import nanoScroller from 'nanoscroller';
import Swiper, {Navigation} from 'swiper';
import {each} from 'jquery';
import {Fancybox} from '@fancyapps/ui/dist/fancybox/fancybox.esm';
import test from './components/test';

test.init();

Swiper.use([Navigation]);

ieFix();
vhFix();
actualYear();

scrollToAnchor.init();
header.init();
lazyLoading.init();

const $document = $(document);
const $window = $(window);
const $html = $('html');
const $body = $('body');

let app = {
	global: {
		init() {
			$('.js-goto').on('click', (e) => {
				let $target = $($(e.currentTarget).data('target') || $(e.currentTarget).attr('href'));

				if ($target.length) {
					e.preventDefault();
					// window.scrollTo(0, $target.offset().top - 100);
					window.scrollTo({
						top: $target.offset().top - 50,
						left: 0,
						behavior: 'smooth',
					});
				}
			});

			if (!vars.isMobile()) {
				let panels = document.querySelectorAll('.section-scroll');

				if (!$('.page').hasClass('page--home')) {
					// плавный scroll - vendor.js
					const lenis = new Lenis({
						duration: 1,
						easing: (t) => Math.min(1, 1.001 - Math.pow(2, -8 * t)), // https://www.desmos.com/calculator/brs54l4xou
						direction: 'vertical', // vertical, horizontal
						gestureDirection: 'vertical', // vertical, horizontal, both
						smooth: true,
						mouseMultiplier: 1,
						smoothTouch: false,
						touchMultiplier: 2,
						infinite: false,
					});

					const raf = (time) => {
						lenis.raf(time);
						requestAnimationFrame(raf);
					};

					requestAnimationFrame(raf);
				}

				panels.forEach((panel, i) => {
					const bg = panel.querySelector('.article__bg');

					ScrollTrigger.create({
						animation: gsap.timeline().to(bg, {
							opacity: 1,
						}),
						scrub: true,
						trigger: panel,
						start: 'bottom bottom',
						end: 'bottom top',
						markers: false,
						once: false,
						pin: true,
						pinSpacing: false,
					});
				});

				$('.nano').nanoScroller();
			}

			Fancybox.defaults.Hash = true;
			Fancybox.defaults.dragToClose = false;
			Fancybox.bind('[data-fancybox]', {
				on: {
					done: () => {
						$('.pop-up.fancybox__content .video-js video').each((index, item) => {
							if (!vars.isMobile()) {
								item.play();
							}
						});
					},
					close: () => {
						$('.video-js video').each((index, item) => {
							item.pause();
						});
					},
				},
			});

			window.addEventListener('load', () => {
				AOS.init({
					offset: 1,
					once: true,
				});
			});

			// video.init();
		},
	},
	home: {
		init($module) {
			const $switchButton = $module.find('.home__switch input');
			let $pin = $module.find('.home__map__pin--real');
			// const $readAlso = $module.find('.home__read-also');
			const $more = $module.find('.home__info__more button');
			const goalsItems = document.querySelectorAll('.home__goals__item');
			const $goals = $module.find('.home__goals');
			let div = false;
			let hover = false;

			function clearGoals() {
				goalsItems.forEach((item) => {
					item.classList.remove('goal--is-active');
				});
			}

			goalsItems.forEach((item) => {
				item.addEventListener('click', () => {
					if (item.classList.contains('goal--is-active')) {
						item.classList.remove('goal--is-active');
					} else {
						clearGoals();
						item.classList.add('goal--is-active');
					}
				});
			});

			$html.attr('data-screen', 'main');

			$($switchButton).change(function () {
				$html.attr('data-theme', this.value);
				let theme = $html.attr('data-theme') || 'real';
				let text = $(this).parent().find('span').text();
				let label = text.charAt(0).toUpperCase() + text.slice(1);
				$pin = $module.find(`.home__map__pin--${theme}`);

				ga('send', 'event', 'main', '2nd screen show', label);

				gtag('event', '2nd_screen_show', {
					event_label: label,
				});

				ym(93591439, 'reachGoal', '2nd screen show', {
					'2nd screen show': {
						type: label,
					},
				});

				if (!vars.isMobile()) {
					const $popUp = $module.find('.home__pop-up');
					const $regions = $module.find('.home__regions');

					$popUp.removeClass('is-active');
					$regions.removeClass('is-hide');
				} else {
					setTimeout(() => {
						const $popUp = $(`.home__pop-up-slider--${theme} .swiper-slide-active .home__pop-up`);
						const name = $popUp.find('.home__pop-up__title').text();

						if ($popUp.length) {
							ga('send', 'event', 'main', 'card show', name);

							gtag('event', 'card_show', {
								event_label: name,
							});

							ym(93591439, 'reachGoal', 'card show', {
								'card show': {
									'card name': name,
								},
							});
						}
					}, 100);
				}

				if (theme === 'real') {
					history.pushState('', document.title, window.location.pathname);

					$('.home__map__path__road--4').addClass('is-delay');
					$('.home__map__path__road--5').addClass('is-delay');

					setTimeout(() => {
						$('.home__map__path__road--4').removeClass('is-delay');
					}, 2400);
				}

				if (theme === 'old') {
					document.location.hash = 'past';
				}

				if (theme === 'future') {
					document.location.hash = 'future';
				}
			});

			$more.on('click', (e) => {
				const $this = $(e.currentTarget);
				const $item = $this.closest('.home__info');
				const $hidden = $item.find('.home__info__list--hidden');
				const $btnShow = $this.find('.home__info__more__show');
				const $btnHide = $this.find('.home__info__more__hide');

				if ($hidden.hasClass('is-hidden')) {
					$hidden.removeClass('is-hidden');
					$btnShow.addClass('is-hidden');
					$btnHide.removeClass('is-hidden');
				} else {
					$hidden.addClass('is-hidden');
					$btnShow.removeClass('is-hidden');
					$btnHide.addClass('is-hidden');
				}
			});

			function beginPage() {
				$module.addClass('is-active-map');
				// $readAlso.removeClass('is-hidden');
				$html.attr('data-theme', 'real');
				$html.attr('data-screen', 'map');

				if (!div) {
					div = true;

					ga('send', 'event', 'main', '2nd screen show', 'Настоящее');

					ym(93591439, 'reachGoal', '2nd screen show', {
						'2nd screen show': {
							type: 'Настоящее',
						},
					});
				}

				setTimeout(() => {
					$('.home__map__path__road--4').removeClass('is-delay');
				}, 2400);
			}

			function checkPopups() {
					let popupList = document.querySelectorAll('.pop-up-news');

					popupList.forEach(function(item, index){
						if (document.location.hash === `#pop-up-news-${index + 1}`) {
							beginPage();

							setTimeout(() => {
								vars.scrollTo($(news), 500, -20);

								setTimeout(() => {
									Fancybox.show([
										{
											src: `#pop-up-news-${index + 1}`,
											type: 'inline',
										},
									]);
								}, 500);
							}, 1000);
						}
					});
				}

			if (vars.isMobile()) {
				// const $map = $module.find('.home__map__image');

				if (document.location.hash === '#future') {
					$pin = $module.find('.home__map__pin--future');
					$html.attr('data-theme', 'future');
					$('.home__switch input[value="future"]').prop('checked', true);
				}

				if (document.location.hash === '#past') {
					$pin = $module.find('.home__map__pin--old');
					$html.attr('data-theme', 'old');
					$('.home__switch input[value="old"]').prop('checked', true);
				}

				window.addEventListener('load', () => {
					const $popUp = $('.swiper-slide-active .home__pop-up');
					const name = $popUp.find('.home__pop-up__title').text();
					let div = false;

					if (!div) {
						div = true;

						ga('send', 'event', 'main', '2nd screen show', 'Настоящее');

						ym(93591439, 'reachGoal', '2nd screen show', {
							'2nd screen show': {
								type: 'Настоящее',
							},
						});

						ga('send', 'event', 'main', 'card show', name);

						gtag('event', 'card_show', {
							event_label: name,
						});

						ym(93591439, 'reachGoal', 'card show', {
							'card show': {
								'card name': name,
							},
						});
					}

					setTimeout(() => {
						$module.addClass('is-active-map-mobile');
					}, 400)

					if (document.location.hash === '#heroes') {
						setTimeout(() => {
							vars.scrollTo($(heroes), 500, -20);
						}, 0);
					}
				});

				$module.find('.home__map__pin--future').first().addClass('is-active-pin');
				$module.find('.home__map__pin--real').first().addClass('is-active-pin');
				$module.find('.home__map__pin--old').first().addClass('is-active-pin');

				$module.find('.home__pop-up-slider .swiper').each(function (i) {
					new Swiper(this, {
						slidesPerView: 'auto',
						spaceBetween: 20,
						autoHeight: true,
						loop: true,
						navigation: {
							prevEl: $module.find('.home__nav__prev')[i],
							nextEl: $module.find('.home__nav__next')[i],
						},
					}).on('slideChange', (e) => {
						$pin.removeClass('is-active-pin');
						$pin.eq(e.realIndex).addClass('is-active-pin');

						setTimeout(() => {
							const $popUp = $(this).find('.swiper-slide-active .home__pop-up');
							const name = $popUp.find('.home__pop-up__title').text();

							ga('send', 'event', 'main', 'card show', name);

							ym(93591439, 'reachGoal', 'card show', {
								'card show': {
									'card name': name,
								},
							});
						}, 100);

						// post = $pin.eq($slider.realIndex).position();

						// $map.css({
						// 	transform: `
						// 	    translateY(-${post.top - map.height() / 2 + $pin.height() / 2}px)
						// 	    translateX(-${post.left - map.width() / 2 + $pin.width()}px)
						// 	    `,
						// });
					});
				});

				checkPopups();

				// let post = $pin.eq($slider.realIndex).position();
				// const map = $module.find('.home__map');
				//
				// $map.css({
				// 	transform: `
				// 	    translateY(-${post.top - map.height() / 2 + $pin.height() / 2}px)
				// 	    translateX(-${post.left - map.width() / 2 + $pin.width()}px)
				// 	    `,
				// });
			} else if (!vars.isMobile()) {
				const $begin = $module.find('.home__begin button');
				const $back = $module.find('.home__back');
				const $regions = $module.find('.home__regions');
				const $regionsButton = $regions.find('.home__regions__button');
				const $mapPin = $module.find('.home__map__pin, .home__read-also .js-read-also-popup');
				const $popUp = $module.find('.home__pop-up');
				const $regionsItem = $module.find('.home__regions__item__list ul li');
				const $mapPath = $module.find('.home__map__path svg path, .home__map__city--7');
				// const $mapCity = $module.find('.home__map__city--7');
				// const $readAlsoButton = $module.find('.home__read-also .js-read-also-popup');
				

				if (document.location.hash === '#future') {
					$module.addClass('is-active-map');
					// $readAlso.removeClass('is-hidden');
					$html.attr('data-theme', 'future');
					$('.home__switch input[value="future"]').prop('checked', true);
				}

				if (document.location.hash === '#past') {
					$module.addClass('is-active-map');
					// $readAlso.removeClass('is-hidden');
					$html.attr('data-theme', 'old');
					$('.home__switch input[value="old"]').prop('checked', true);
				}

				if (document.location.hash === '#heroes') {
					beginPage();

					setTimeout(() => {
						vars.scrollTo($(heroes), 500, -20);
					}, 1000);
				}

				if (document.location.hash === '#news') {
					beginPage();

					setTimeout(() => {
						vars.scrollTo($(news), 500, -20);
					}, 1000);
				}

				checkPopups();

				$begin.on('click', () => {
					beginPage();
				});

				$back.on('click', () => {
					const $switchButtonReal = $module.find('.home__switch input[value="real"]');

					history.pushState('', document.title, window.location.pathname);

					$switchButton.prop('checked', false);
					$switchButtonReal.prop('checked', true);
					$module.removeClass('is-active-map');
					// $readAlso.addClass('is-hidden');
					$popUp.removeClass('is-active');
					$html.attr('data-theme', 'real');
					$html.attr('data-screen', 'main');
					$('.home__map__path__road--4').addClass('is-delay');
				});

				// $window.on('wheel', (e) => {
				// 	if (e.originalEvent.deltaY > 0) {
				// 		$module.addClass('is-active-map');
				// 		$readAlso.removeClass('is-hidden');

				// 		if (!div) {
				// 			div = true;

				// 			ga("send", "event", "main", "2nd screen show");
				// 		}
				// 	}
				// 	if (e.originalEvent.deltaY < 0 && !hover) {

				// 		if (window.pageYOffset == 0) {
				// 			$module.removeClass('is-active-map');
				// 			$readAlso.addClass('is-hidden');
				// 			$popUp.removeClass('is-active');
				// 		}
				// 	}
				// });

				$popUp.on({
					mouseenter: () => {
						hover = true;
					},
					mouseleave: () => {
						hover = false;
					},
				});

				$regionsButton.on('click', (e) => {
					const $this = $(e.currentTarget);

					if ($this.hasClass('is-show-regions')) {
						$this.removeClass('is-show-regions');
					} else {
						$this.addClass('is-show-regions');
					}

					ga('send', 'event', 'main', 'regions dropdown');

					gtag('event', 'regions_dropdown');

					ym(93591439, 'reachGoal', 'regions dropdown', {'regions dropdown': 'click'});
				});

				$regionsItem.on({
					mouseenter: (e) => {
						const $this = $(e.currentTarget);

						$mapPath.removeClass('is-active');

						$mapPath.each((index, item) => {
							const $item = $(item);

							if ($item.data('item')) {
								const value = $item.data('item').toString().split(',');

								if (value.includes($this.data('item').toString())) {
									$item.addClass('is-active');
								}
							}
						});
					},
					mouseleave: () => {
						$mapPath.each((index, item) => {
							const $item = $(item);

							if ($item.data('item')) {
								$item.addClass('is-active');
							}
						});
					},
				});

				// $mapPath.on({
				// 	mouseenter: (e) => {
				// 		const $this = $(e.currentTarget);
				//
				// 		if ($this.data('point') !== 1) {
				// 			$mapPath.removeClass('is-active');
				//
				// 			if ($this.data('point') === 2) {
				// 				$(`.home__map__path path[data-point='1']`).addClass('is-active');
				// 				$(`.home__map__path path[data-point='3']`).addClass('is-active');
				// 			}
				//
				// 			if ($this.data('point') === 4) {
				// 				$(`.home__map__path path[data-point='3']`).addClass('is-active');
				// 				$(`.home__map__path path[data-point='5']`).addClass('is-active');
				// 				$mapCity.addClass('is-active');
				// 			}
				//
				// 			$regionsItem.each((index, item) => {
				// 				const $item = $(item);
				//
				// 				if ($item.data('point')) {
				// 					const value = $item.data('point').toString().split(',');
				//
				// 					if (value.includes($this.data('point').toString())) {
				// 						$item.addClass('is-active');
				// 						$this.addClass('is-active');
				// 					}
				// 				}
				// 			})
				// 		}
				// 	},
				// 	mouseleave: () => {
				// 		$regionsItem.removeClass('is-active');
				//
				// 		$mapPath.each((index, item) => {
				// 			const $item = $(item);
				//
				// 			if ($item.data('point')) {
				// 				$item.addClass('is-active');
				// 				$mapCity.addClass('is-active');
				// 			}
				// 		})
				// 	}
				// });

				$mapPin.on('click', (e) => {
					const $this = $(e.currentTarget);

					$popUp.each((index, item) => {
						const $item = $(item);
						const $close = $item.find('.home__pop-up__close');

						if ($this.data('pop-up') === $item.data('pop-up')) {
							const name = $item.find('.home__pop-up__title').text();

							$popUp.removeClass('is-active');
							$item.addClass('is-active');
							$regions.addClass('is-hide');
							$goals.addClass('is-remove');

							$('.video-js video').each((index, item) => {
								item.pause();
							});

							ga('send', 'event', 'main', 'card show', name);

							ym(93591439, 'reachGoal', 'card show', {
								'card show': {
									'card name': name,
								},
							});
						}

						$close.on('click', () => {
							$item.removeClass('is-active');
							$regions.removeClass('is-hide');
							$goals.removeClass('is-remove');

							$('.video-js video').each((index, item) => {
								item.pause();
							});
						});
					});
				});

				// $readAlsoButton.on('click', () => {
				// 	vars.scrollTo($('.page'), 0);
				// });
			}

			const $openWidow = $('.js-open-id-fancybox');

			if (location.hash.replace('#', '') === $openWidow.attr('id')) {
				$window.on('load', () => {
					$module.addClass('is-active-map');
					$html.attr('data-theme', 'real');
					$html.attr('data-screen', 'map');

					setTimeout(() => {
						window.scrollTo(0, $openWidow.offset().top - 100);

						Fancybox.show([
							{
								src: $openWidow.attr('href'),
								type: 'inline',
							},
						]);
					}, 100);
				});
			}
		},
	},
	parallaxImg: {
		init($module) {
			if (!vars.isMobile()) {
				$window.on('scroll', () => {
					$module.find('[data-depth]').each((index, item) => {
						const top = ($module.offset().top - ($window.scrollTop() + $window.outerHeight())) / (10 / parseFloat($(item).data('depth')));

						$(item).css({
							transform: `translateY(${top}px)`,
						});
					});
				});
			}
		},
	},
	footer: {
		init($module) {
			if (vars.isMobile()) {
				let $infoTeam = $module.find('.footer__info__team button');
				let $team = $module.find('.footer__team');
				let $close = $module.find('.footer__team__close');

				$infoTeam.on('click', () => {
					$team.addClass('is-show-team');
				});

				$close.on('click', () => {
					$team.removeClass('is-show-team');
				});
			}
		},
	},
};

app.global.init();

window.initApps = () => {
	$('[data-app]').each((index, item) => {
		let $this = $(item);
		let split = $this.data('app').split('||');

		$.each(split, (appIndex, appName) => {
			let appNameCamel = false;

			if (appName.indexOf('-') !== -1) {
				appNameCamel = appName.replace(/(-|\s)(\S)/ug, (m) => m.toUpperCase()).replace(/-/ug, '');
			}

			if (app[appName] && $this.data(`${appName}-init`) !== true) {
				app[appName].init($this);
				$this.data(`${appName}-init`, true);
			} else if (app[appNameCamel] && $this.data(`${appName}-init`) !== true) {
				app[appNameCamel].init($this);
				$this.data(`${appName}-init`, true);
			}
		});
	});
};

initApps();
